import React, { useEffect, useState } from "react";
import styles from "./classes.module.css";
import { Col, Row, Spin, Typography } from "antd";
import CustomButton from "../../../../../../common/custom-button/custom-button";
import {
  fetchTeacherWeeklyClasses,
  getTeacherWeeklyClassesForExport,
} from "../../../../../../services/teachers";
import moment from "moment";
import { Calendar, momentLocalizer } from "react-big-calendar";
import "react-big-calendar/lib/css/react-big-calendar.css";
import { getThisWeeksEvents } from "../../../../../../utils/common";
import { toast } from "react-toastify";

const Classes = ({ teacherID }) => {
  const localizer = momentLocalizer(moment);
  const [loading, setLoading] = useState(false);
  const [scheduleData, setScheduleData] = useState([]);

  useEffect(() => {
    teacherID && getTeacherClassData();
  }, [teacherID]);

  const handleExportCSV = async () => {
    try {
      setLoading(true);
      const response = await getTeacherWeeklyClassesForExport(teacherID);

      if (response?.status) {
        setLoading(false);
        const blob = new Blob([response?.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `weekly classes.xlsx`);
        document.body.appendChild(link);
        link.click();
        link.remove();
      }
    } catch (error) {
      console.error(error);
      toast.error("Failed to export file.");
    }
  };

  const getTeacherClassData = async () => {
    try {
      setLoading(true);
      const response = await fetchTeacherWeeklyClasses(teacherID);
      if (response?.data?.data?.length) {
        const tempClassSchedules = [];
        const classWeekData = response?.data?.data?.length
          ? response.data.data
          : [];
        classWeekData.map((e) => {
          const classData = e?.class_list?.length ? e.class_list : [];
          classData.map((el) => {
            tempClassSchedules.push({
              day: el?.day,
              start_time: el?.start_time
                ? moment(el.start_time, "HH:mm:ss").format("h:mmA")
                : null,
              end_time: el?.end_time
                ? moment(el.end_time, "HH:mm:ss").format("h:mmA")
                : null,
              title: `${el?.subject_info[0]?.subject} - ${el?.form_name} - ${el?.section_name}`,
            });
          });
        });
        const slotsData = getThisWeeksEvents(tempClassSchedules);
        setScheduleData(slotsData);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log("error", error);
    }
  };

  return (
    <div className={styles.attendance}>
      <div className={styles.headerContainer}>
        <Typography className={styles.headerTitle}>Classes</Typography>

        <CustomButton
          title="Export Classes CSV"
          onClick={handleExportCSV}
          style={{
            background: "rgba(57, 181, 74, 0.10)",
            border: "1px solid #F5F5F5",
            color: "#39B54A",
            fontWeight: 500,
            fontSize: "14px",
          }}
          iconPosition={"end"}
          icon={<img src="/assets/images/export-icon.svg" alt="mail" />}
        />
      </div>
      <Spin spinning={loading}>
        <Row gutter={24}>
          <Col span={24}>
            <div className={styles.calendarWrapper}>
              <Calendar
                localizer={localizer}
                events={scheduleData}
                defaultView="week"
                views={["week", "day"]}
                defaultDate={new Date()}
                scrollToTime={new Date()}
                style={{ height: 600 }}
                eventPropGetter={() => ({
                  style: {
                    whiteSpace: "normal",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "100px",
                    height: "100%",
                    fontSize: "12px",
                    padding: "4px",
                    textAlign: "center",
                  },
                })}
                components={{
                  timeSlotWrapper: ({ children }) => (
                    <div style={{ minHeight: "50px" }}>{children}</div>
                  ),
                }}
              />
            </div>
          </Col>
        </Row>
      </Spin>
    </div>
  );
};

export default Classes;
